import Auth from "../../services/auth";
import Store from "../../store";

export default function(to, from, next) {
    if (to.matched.some(record => record.meta.auth) && !Auth.isLoggedIn()) {
        return next({
            path: "/shop/login",
            query: { redirect: to.fullPath }
        });
    } else {
        if (
            to.matched.some(record => record.meta.isAdmin) &&
            Store.getters.user.role !== "admin" &&
            Store.getters.user.role !== "superadmin"
        ) {
            next("/");
        } else if (
            to.matched.some(record => record.meta.isNso) &&
            Store.getters.user.role !== "nso"
        ) {
            next("/");
        } else if (
            to.matched.some(record => record.meta.isCvb) &&
            Store.getters.user.role !== "cvb"
        ) {
            next("/");
        } else if (
            to.matched.some(record => record.meta.isHotel) &&
            Store.getters.user.role !== "hotel"
        ) {
            next("/");
        } else {
            if(Auth.isLoggedIn() && to.name == 'login'){
                next("/shop/account");
            }else{
                next();
            }
        }
    }
}
